import { useIntl } from 'react-intl';
import AIEduDialog from '../../../components/Dialog/AIEduDialog';
import AIEduDialogFooter from '../../../components/Footer/AIEduDialogFooter';

const RegenerateKeyDialog = ({ visible, onHide, onConfirm }) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;

    const content = () => {
        return (
            <div className='flex align-items-center justify-content-center ml-2 mr-2'>
                {f({ id: 'AI_EDU_REGENERATE_KEY_MESSAGE' })}
            </div>
        );
    };

    const footer = (
        <AIEduDialogFooter
            onConfirm={onConfirm}
            onCancel={onHide}
            confirmLabel={f({ id: 'AI_EDU_REGENERATE' })}
            cancelLabel={f({ id: 'AI_EDU_CANCEL' })}
        />
    );

    return (
        <AIEduDialog
            visible={visible}
            onHide={onHide}
            title={f({ id: 'AI_EDU_REGENERATE_KEY_TITLE' })}
            content={content()}
            footer={footer}
            style={{ width: '40vw' }}
            draggable={false}
            modal
            closable
            dismissableMask
        />
    );
};

export default RegenerateKeyDialog;
